module.exports = __webpack_public_path__ + "images/emoji/cd.717963d91d059252b7d4.png";